import { Cloud, CloudDrizzle, LoaderCircle } from "lucide-react"

interface RainfallSummaryProps {
        rainfallResult: number | null;
        rainfallLoading: boolean;
        rainfallError?: string | null;

}

export const RainfallSummary = ({rainfallResult, rainfallLoading, rainfallError}: RainfallSummaryProps) => {
    
    if (rainfallResult === null) {
        return null;
    }

    if (rainfallError) {
        return (
            <section className="rounded-xl w-full bg-white shadow-sm border border-gray-200 p-4 space-y-4">
                <div className="flex flex-row gap-2 text-gray-600 items-center ">
                    <Cloud size={20} />
                    <label className="block text-md font-medium text-gray-900">Precipitação acumulada no período</label>
                </div>
                <div className="flex items-center flex-1 justify-center">
                    <span className="text-sm text-red-700 font-justify">{rainfallError}</span>
                </div>
            </section>
        )
    }

    return (
        <section className="rounded-xl w-full bg-white shadow-sm border border-gray-200 p-4 space-y-4">
          <div className="flex flex-row gap-2 text-gray-600 items-center ">
            <Cloud size={20} />
            <label className="block text-md font-medium text-gray-900">Precipitação acumulada no período</label>
          </div>
          {rainfallLoading && (
            <div className="flex items-center flex-1 justify-center">
                <LoaderCircle className="animate-spin " size={20} />
            </div>
          )}
            <div className="space-x-2 w-full text-gray-400 flex items-center justify-between">
                <CloudDrizzle size={20} />
                <div className="flex items-center justify-between gap-2 flex-1">
                    <div className="w-full flex-1">
                        <span className="text-gray-500 text-[22px] font-semibold">
                        {`${rainfallResult.toFixed(2)}`}
                        </span>
                    </div>
                </div>
                <div className="flex items-center justify-end gap-2">
                <span className="text-lg text-end font-medium">
                    mm
                </span>
                </div>
            </div>
        </section>
    )
}